import { UserOutlined } from '@ant-design/icons';
import { type DatiSessioneUtente } from '@framework/api-client/api/users/schemas/datiSessioneUtente.ts';
import { Button, type ButtonProps } from 'antd';
import styled from 'styled-components';

const StyledUserButton = styled(Button)`
  &&& {
    &:focus-visible {
      outline: 2px solid ${props => props.theme.focusOutlineNegativeColor} !important;
      outline-offset: 0px !important;
      transition: all 0.2s;
    }
  }
`;

export interface IFrontUserButtonProps extends Omit<ButtonProps, 'type'> {
  currentUser?: DatiSessioneUtente | null;
  isMobile?: boolean | null;
}
/**
 * Bottone personalizzato per il menu utente lato compilazione
 * Visualizza il nome, il ruolo e l'ufficio dell'utente loggato.
 */
export function FrontUserButton(props: IFrontUserButtonProps) {
  const { currentUser, isMobile, ...buttonProps } = props;

  const name =
    (currentUser?.utenteLoggato?.nome ?? '') +
    ' ' +
    (currentUser?.utenteLoggato?.cognome ?? '');

  return (
    <StyledUserButton
      aria-haspopup
      aria-label="menu utente"
      size="large"
      type="primary"
      icon={<UserOutlined aria-hidden />}
      {...buttonProps}
    >
      {!isMobile && name}
    </StyledUserButton>
  );
}
